export const OperatorServiceForm: ng.IComponentOptions = {
  bindings: {
    model: '=',
    operator: '=',
    startDate: '=',
    endDate: '=',
    aliases: '=',
    selectedSchemes: '='
  },
  templateUrl: 'app/angularJS/components/forms/operator-service/operator-service-form.html',
  controller: 'OperatorServiceFormController',
  controllerAs: 'vm'
};